import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { updatePrivateRelayEmail, } from '../../../../service/updatePrivateRelayEmail/updatePrivateRelayEmail.js';
import { authSuccessThunk } from '../../../../core/authSuccess/authSuccessSlice.js';
import { setEmailUpdateRequired } from '../../../../features/loginWithApple/loginWithAppleSlice.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { trackAppleEmailChangeSuccessfulRequest, trackFailedRequest, } from '../../../../tracking/index.js';
export const initialAppleUpdateEmailState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    errorStatus: null,
    isLoading: false,
};
export const updateAppleEmailThunk = createAsyncThunk('appleUpdateEmail/update', async (email, { rejectWithValue, dispatch }) => {
    try {
        const data = await updatePrivateRelayEmail({ email });
        console.log('updatePrivateRelayEmail, data: ', data);
        if (data.status === 204) {
            dispatch(sendGlobalTrackingThunk(trackAppleEmailChangeSuccessfulRequest));
            dispatch(setEmailUpdateRequired(false));
            dispatch(authSuccessThunk('apple', data.status, {
                apple: { emailUpdateRequired: false },
            }));
            return data;
        }
        if (data.status === 409) {
            dispatch(sendGlobalTrackingThunk(trackFailedRequest, {
                formFailedAttemptsErrors: 'emailAlreadyUsedError',
                componentState: 'postAppleLoginAddYourEmailForm',
            }));
        }
        return rejectWithValue(data);
    }
    catch (error) {
        console.log('apple login - signIn, error: ', error);
        dispatch(sendGlobalTrackingThunk(trackFailedRequest, {
            formFailedAttemptsErrors: 'otherGenericError',
            componentState: 'postAppleLoginAddYourEmailForm',
        }));
        return rejectWithValue({
            status: 500,
        });
    }
});
const appleUpdateEmailSlice = createSlice({
    name: 'appleUpdateEmail',
    initialState: initialAppleUpdateEmailState,
    reducers: {
        updateEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateAppleEmailThunk.pending, (state) => {
            state.isLoading = true;
            state.errorStatus = null;
        })
            .addCase(updateAppleEmailThunk.fulfilled, (state) => {
            state.isLoading = false;
            state.errorStatus = null;
        })
            .addCase(updateAppleEmailThunk.rejected, (state, actions) => {
            state.isLoading = false;
            state.errorStatus = actions.payload?.status || 500; // add component to display this error
        });
    },
});
export const { updateEmail, updateEmailError, updateEmailErrorMessage } = appleUpdateEmailSlice.actions;
const appleUpdateEmailState = (state) => state.forms.appleUpdateEmail;
export const emailSelector = createSelector(appleUpdateEmailState, ({ email }) => email);
export const errorStatusSelector = createSelector(appleUpdateEmailState, ({ errorStatus }) => errorStatus);
export const isLoadingSelector = createSelector(appleUpdateEmailState, ({ isLoading }) => isLoading);
export default appleUpdateEmailSlice.reducer;
//# sourceMappingURL=appleUpdateEmailSlice.js.map